module.exports = "textarea.mat-input-element {\n  overflow-y: hidden; }\n\n.hidden {\n  display: none; }\n"